// const stripTrailingSlash = (s: string) => s.replace(/\/+$/, "");

// export const API_BASE =
//   (import.meta as any).env?.VITE_API_URL
//     ? stripTrailingSlash((import.meta as any).env.VITE_API_URL)
//     : "http://localhost:8082";

// export const WS_URL =
//   (import.meta as any).env?.VITE_WS_URL
//     ? stripTrailingSlash((import.meta as any).env.VITE_WS_URL)
//     : `${API_BASE}/ws`;


const stripTrailingSlash = (s: string) => s.replace(/\/+$/, "");
const stripTrailingApiSegment = (s: string) => s.replace(/\/api$/i, "");

const ORIGIN = stripTrailingSlash(window.location.origin);
// behind nginx
console.log("ORIGIN: ", ORIGIN);

console.log("MODE", import.meta.env.MODE);
console.log("API", import.meta.env.VITE_API_URL);
console.log("WS", import.meta.env.VITE_WS_URL);


export const API_BASE =
  (import.meta as any).env?.VITE_API_URL
    ? stripTrailingApiSegment(stripTrailingSlash((import.meta as any).env.VITE_API_URL))
    : `${ORIGIN}`; // behind nginx (only works in production)

export const WS_URL =
  (import.meta as any).env?.VITE_WS_URL
    ? stripTrailingSlash((import.meta as any).env.VITE_WS_URL)
    : `${ORIGIN}/ws`; 
